var loadMoreButton = document.getElementById("loadMoreButton");

if (loadMoreButton !== undefined && loadMoreButton !== null) {
    loadMoreButton.addEventListener("click", loadMore);
}

var buttons = document.querySelectorAll('.button--filter');
var buttonItems = [].slice.call(buttons);

buttonItems.forEach(function (item, idx) {
    item.addEventListener('click', getCategoryOverview);
});

var currentPageCount = 1;
var activeCategoryId = 0;

function hideParagraphs() {
    var paragraphs = document.querySelectorAll('.paragraph--main');
    var paragraphItems = [].slice.call(paragraphs);

    paragraphItems.forEach(function (item) {
        item.style.display = "none";
    });
}

function getCategoryOverview(event) {
    event.preventDefault();

    hideParagraphs();

    if (currentPageCount > 1) {
        currentPageCount = 1;
    }

    var el = this;

    var parentContainer = el.closest(".carousel");

    var blockId = parentContainer.getAttribute('data-blockid');
    var action = parentContainer.getAttribute('data-action');
    var language = parentContainer.getAttribute('data-language');
    var currentPage = 1;

    var categoryId = el.getAttribute('data-categoryid');

    activeCategoryId = categoryId;

    var paragraph = document.getElementById("paragraph_" + activeCategoryId);

    paragraph.style.display = "block";

    clearFilterButtons();

    el.classList.add("is-active");

    getPageOverview(blockId, action, currentPage, categoryId, language);
}

function clearFilterButtons() {
    buttonItems.forEach(function (item) {
        item.classList.remove("is-active");
    });
}

function loadMore(event) {
    event.preventDefault();

    var el = this;
    var blockId = el.getAttribute('data-blockid');
    var action = el.getAttribute('data-action');
    var language = el.getAttribute('data-language');
    var currentPage = currentPageCount;

    getPageOverview(blockId, action, currentPage, activeCategoryId, language);
}

function getPageOverview(blockId, action, currentPage, categoryId, language) {
    fetch(action, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({ blockId: blockId, language: language, currentPage: currentPage, categoryId: categoryId })
    })
        .then((res) => res.text())
        .then(function (html) {
            var overview = document.getElementById("loadMoreOverview");

            overview.innerHTML = html;

            var totalPages = document.getElementById("totalPages");

            var showLoadMoreButton = currentPage < totalPages.value;

            var loadMoreButton = document.getElementById("loadMoreButton");

            if (showLoadMoreButton) {
                loadMoreButton.style.display = "inline-flex";
            }
            else {
                loadMoreButton.style.display = "none";
            }

            currentPageCount++;
        })
        .catch((err) => console.log(err));
}

function initPage() {
    var collectionExists = document.getElementById("collection");

    if (collectionExists === undefined || collectionExists === null) {
        return;
    }

    hideParagraphs();

    var defaultParagraph = document.getElementById("paragraph_0");

    defaultParagraph.style.display = "block";

    var el = document.getElementById("loadMoreButton");
    var blockId = el.getAttribute('data-blockid');
    var action = el.getAttribute('data-action');
    var language = el.getAttribute('data-language');
    var currentPage = currentPageCount;
    var categoryId = 0;

    var overrideCategory = el.getAttribute('data-overridecategory');

    if (overrideCategory !== null &&
        overrideCategory !== undefined &&
        overrideCategory !== '') {
        categoryId = overrideCategory;

        hideParagraphs();

        activeCategoryId = categoryId;

        var paragraph = document.getElementById("paragraph_" + activeCategoryId);

        paragraph.style.display = "block";

        clearFilterButtons();

        var button = document.getElementById("categoryButton" + categoryId);

        button.classList.add("is-active");
    }

    getPageOverview(blockId, action, currentPage, categoryId, language);
}

initPage();